<template>
  <w-app>
    <div>
      <w-toolbar shadow class="py1">
        <div id="placepicker">
          <svg width="1000" height="115">
            <image xlink:href="https://www.bekoeurope.com/media/hiekdpq5/logo-en.png" x="0" y="0"></image><text x="800"
              y="75" text-anchor="end" fill="#021d48" font-size="70" font-weight="bold">MultiService</text>
          </svg>
        </div>
        <div class="spacer"></div>

        <w-button icon="mdi mdi-cart " text lg class="ml3" @mouseover="toggleSExpandY = !toggleSExpandY" color="primary"
          outline></w-button>
        <w-transition-expand y>
          <div v-if="toggleSExpandY">Shopping Cart</div>
        </w-transition-expand>

        <w-button icon="mdi mdi-account " text lg class="ml3" @mouseover="toggleAExpandY = !toggleAExpandY"
          color="primary" outline></w-button>
        <w-transition-expand y>
          <button v-if="toggleAExpandY" @click="logout">Logout</button>
        </w-transition-expand>

      </w-toolbar>
      <ModelSearch></ModelSearch>
    </div>
  </w-app>
</template>

<script>
import ASWOSearch from "../components/ASWOSearch.vue";
import ModelSearch from '../components/ModelSearch.vue'

import router from "@/router";
import { googleLogout } from "vue3-google-login";

export default {
  name: "App",
  components: {
    ASWOSearch,
    ModelSearch
  },

  data() {

    const logout = () => {
      googleLogout()
      router.push('/login')
    }
    return {
      toggleAExpandY: false,
      toggleSExpandY: false,
      logout

    };
  }
};

</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #103861;
}

.w-app .primary--bg {
  background-color: #021d48;
}

.transition-toggle {
  margin: 12px 24px 12px 0;
  width: 7.7em;
}

.transition-box {
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 1em;
  width: 14em;
  text-align: center;
}
</style>
